// actions/transactionActions.js
import {
  FETCH_TRANSACTIONS_REQUEST,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTIONS_FAILURE,
  REFUND_TRANSACTION_REQUEST,
  REFUND_TRANSACTION_SUCCESS,
  REFUND_TRANSACTION_FAILURE,
} from "./types";

import { fetchTransactions, refundTransaction } from "../../services/transactionService";

// Action Creators
export const fetchTransactionsRequest = () => ({ type: FETCH_TRANSACTIONS_REQUEST });

export const fetchTransactionsSuccess = (transactionsData) => ({
  type: FETCH_TRANSACTIONS_SUCCESS,
  payload: transactionsData,
});

export const fetchTransactionsFailure = (error) => ({
  type: FETCH_TRANSACTIONS_FAILURE,
  payload: error,
});

// Refund Actions
export const refundTransactionRequest = () => ({
  type: REFUND_TRANSACTION_REQUEST,
});

export const refundTransactionSuccess = (data) => ({
  type: REFUND_TRANSACTION_SUCCESS,
  payload: data,
});

export const refundTransactionFailure = (error) => ({
  type: REFUND_TRANSACTION_FAILURE,
  payload: error,
});

// Thunk to fetch transactions
export const fetchTransactionsAction = (filterField, filterValue, page = 1, size = 50) => async (dispatch) => {
  dispatch(fetchTransactionsRequest());

  try {
    const response = await fetchTransactions(filterField, filterValue, page, size);

    if (response.error) {
      dispatch(fetchTransactionsFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchTransactionsSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchTransactionsFailure(error.message || "Failed to fetch transactions"));
    return { success: false, error: error.message || "Failed to fetch transactions" };
  }
};

// Thunk to refund a transaction
export const refundTransactionAction = (paygateTransactionId) => async (dispatch) => {
  dispatch(refundTransactionRequest());

  try {
    const response = await refundTransaction(paygateTransactionId);

    if (response.error) {
      dispatch(refundTransactionFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(refundTransactionSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(refundTransactionFailure(error.message || "Refund failed"));
    return { success: false, error: error.message || "Refund failed" };
  }
};